import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationENG from "locales/en.json";
import translationPTBR from "locales/ptbr.json";
import translationSP from "locales/sp.json";

const resources = {
  ptbr: {
    translation: translationPTBR,
  },
  en: {
    translation: translationENG,
  },
  sp: {
    translation: translationSP,
  },
};

const defaultLanguage = "ptbr";
const language = localStorage.getItem("I18N_LANGUAGE");

if (!language) {
  localStorage.setItem("I18N_LANGUAGE", defaultLanguage);
}

const currentLanguage = localStorage.getItem("I18N_LANGUAGE") || defaultLanguage;

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    lng: currentLanguage,
    fallbackLng: defaultLanguage,

    detection: {
      order: ["localStorage"],
      lookupLocalStorage: "I18N_LANGUAGE",
      caches: ["localStorage"],
    },

    keySeparator: false,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
